import React from 'react';
import { DetailedStickerType } from '../../molecules/types';
import Best from './best';
import Award from './award';
import Like from './like';

type Props = {
  detailedSticker: DetailedStickerType;
  scale: number;
};

export const isDetailedStickerAvailable = (detailedSticker: DetailedStickerType): boolean => {
  return ['best', 'award', 'like'].includes(detailedSticker?.family);
};

const DetailedSticker = ({ detailedSticker, scale }: Props) => {
  if (detailedSticker && detailedSticker?.family) {
    switch (detailedSticker.family) {
      case 'best':
        return <Best label={detailedSticker.name} scale={scale} />;
      case 'award':
        return <Award label={detailedSticker.name} scale={scale} />;
      case 'like':
        return <Like label={detailedSticker.name} scale={scale} />;
      default:
        return null;
    }
  }

  return null;
};

export default DetailedSticker;
